import { states as STATES, countries as COUNTRIES } from "../../../data/trialForm";
import { encodeBase64 } from '../utils/helpers';
import { otRecaptcha } from '../utils/recaptcha';

const spinnerIcon = require("../../../../assets/svg/ui/spinner.svg") as string;

const FAKE_VALUES: boolean = false;
const FAKE_FETCH: boolean = false;
// const FAKE_VALUES: boolean = true;
// const FAKE_FETCH: boolean = true;

export const otTrialForm = {
    FORM_DATA_ATTR: 'data-ot-trial-form',
    init() {
        const $forms: NodeListOf<HTMLFormElement> = document.querySelectorAll(`[${this.FORM_DATA_ATTR}]`);

        $forms.forEach(($form) => {
            FAKE_VALUES && populateTestValues($form as HTMLFormElement); // For testing
            this.configureStateSelect($form);
            this.populateHiddenFields($form);
            this.bindUIEvents($form);
        });
    },
    configureStateSelect($form: HTMLFormElement) {
        // Toggle State select field if selected country has associated state object
        const $countrySelect = $form.querySelector('[data-ot-country-select="trial-form"]') as HTMLSelectElement
        const $stateSelect = $form.querySelector('[data-ot-state-select]') as HTMLSelectElement;
        const $consent = $form.querySelector('[data-ot-consent]') as HTMLElement;

        const consentRequired = ["AT","BE","BG","CH","CY","CZ","DE","DK","EE","ES","FI","FR","GB","GR","HR","HU","IE","IS","IL","IT","LI","LU","LT","LV","MT","NL","NO","PL","PT","RO","SE","SI","SK","CN","EG","JP","KE","MX","QA","ZA","TR","AU","NZ","CA"]

        $countrySelect?.addEventListener('change', (_) => {
            const countryStates = STATES.find(country => country.code === $countrySelect.value);
            const hideConsent = !consentRequired.includes($countrySelect.value);
            const $radioInputs = $consent.querySelectorAll('input[type="radio"]') as NodeListOf<HTMLInputElement>;

            $consent.hidden = hideConsent;
            $consent.classList.toggle('flex', !hideConsent);

            $radioInputs.forEach($input => {
                $input.checked = $input.value === 'on' && hideConsent;
            });

            $stateSelect.innerHTML = '';

            if (countryStates) {
                const $option = document.createElement('option');

                // Default value
                $option.value = '';
                $option.innerText = '-- Please Select --';
                $option.disabled = true;
                $option.selected = true;

                $stateSelect?.appendChild($option);

                // Populate options from JSON
                countryStates.liststates?.map(state => {
                    const $option = document.createElement('option');

                    $option.value = state.stateCode;
                    $option.innerText = state.stateName;

                    $stateSelect?.appendChild($option);
                });

                $stateSelect.required = true;
                $stateSelect?.closest('[data-ot-input-group]')?.removeAttribute('hidden');
            } else {
                $stateSelect.required = false;
                $stateSelect?.closest('[data-ot-input-group]')?.setAttribute('hidden', '');
            }
        });
    },
    bindUIEvents($form: HTMLFormElement) {
        const $recaptcha = $form.querySelector('.g-recaptcha');

        if ($recaptcha) {
            function loadRecaptchaScript() {
                otRecaptcha.appendScript($form);

                $form.removeEventListener('input', loadRecaptchaScript);
                $form.removeEventListener('focus', loadRecaptchaScript);
            }

            // Load recaptcha on interaction with an input. Use both input and focus events for redundancy as a safety net
            $form.addEventListener('input', loadRecaptchaScript);
            $form.addEventListener('focus', loadRecaptchaScript, true);
        }

        $form.querySelector('[data-ot-country-select="trial-form"]')?.addEventListener('focus', e => {
            const $select = e.target as HTMLSelectElement;

            // Only append once
            if ($select.dataset.populated) return;
            $select.dataset.populated = 'true';

            COUNTRIES.forEach(country => {
                const option = document.createElement("option");

                option.value = country.code;
                option.innerText = country.country;
                $select.append(option);
            });

            // Force selection back to placeholder (index 0)
            $select.selectedIndex = 0;
        });

        $form.addEventListener('submit', e => {
            e.preventDefault();
            this.submitForm($form);
        });
    },
    async resendEmail($formSuccess, $btn, resendEndpoint) {
        const btnInitText = $btn.innerText;
        const btnTextSubmitting = 'Resending...';
        const errorText = 'There was an error while attempting to resend the verification email. Please try again.';
        const $status = $formSuccess.querySelector('[data-ot-success-status]');

        const request = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            // mode: 'cors'
        };

        $btn.innerText = btnTextSubmitting;

        try {
            await this.doFetch({ url: resendEndpoint, request, $btn });

            if ($status) {
                $status.innerHTML = '<p class="text-sm">Verification email has been resent</p>';
            }
        } catch (error) {
            $btn.innerText = btnInitText;

            if ($status) {
                $status.innerHTML = `<p class="text-error text-sm">${errorText}</p>`;
            }
            console.error(error)
        } finally {
            $btn.innerText = btnInitText;
            $btn.ariaDisabled = 'false';
        }
    },
    async submitForm($form: HTMLFormElement) {
        const url = $form.getAttribute(this.FORM_DATA_ATTR);

        if (!url) return;

        const formData = new FormData($form);
        const formDataObjectString = JSON.stringify(Object.fromEntries(formData));
        const formDataObject = JSON.parse(formDataObjectString);

        const requestBody = {
            ...formDataObject,
            tenantUserPassword: encodeBase64(formDataObject.tenantUserPassword),
            tenantUserPasswordConfirm: encodeBase64(formDataObject.tenantUserPasswordConfirm),
            prefReqForm: formDataObject.prefReqForm === 'on',
            agree: formDataObject.agree === 'true',
            maxUsersAllowed: parseInt(formDataObject.maxUsersAllowed),
        };

        const request = {
            method: "POST",
            body: JSON.stringify(requestBody),
            headers: {
                'Content-Type': 'application/json',
            },
            // mode: 'cors'
        };

        const $status = $form.querySelector('[data-ot-form-status]');
        const $btn = $form?.querySelector('[data-ot-form-submit]') as HTMLButtonElement;

        const btnInitText = $btn.innerText;
        const btnTextSubmitting = 'Submitting...';
        const btnTextSuccess = 'Submitted';
        const errorText = 'There was an error with your submission. Please try again.';

        $btn.innerText = btnTextSubmitting;

        try {
            const result = await this.doFetch({ url, request, $btn });
            const redirectUrlParams = result.redirectUrl && new URL(result.redirectUrl).searchParams;
            const verificationId = redirectUrlParams ? redirectUrlParams.get('verificationId') : '';

            $btn.innerText = btnTextSuccess;
            this.showSuccessState($form, formDataObject, verificationId);
        } catch (error) {
            $btn.innerText = btnInitText;
            $btn.ariaDisabled = 'false';

            if ($status) {
                $status.innerHTML = `<p class="text-error text-sm">${errorText}</p>`;
            }
            console.error(error)
        }
    },
    async doFetch({ url, request, $btn }: { url: string; request: RequestInit; $btn: HTMLButtonElement }) {
        $btn.ariaDisabled = 'true';
        $btn.append(this.createSpinner());

        const doFakeFetch = FAKE_FETCH || url === 'fake-fetch';

        try {
            // Show loading state
            const response: Response | null = doFakeFetch
                ? await new Promise((resolve, reject) => {
                    setTimeout(() => {
                        resolve(new Response(JSON.stringify({ message: "ok" }), { status: 200 }));
                        // To simulate an error, replace the above with:
                        // resolve(new Response(null, { status: 500, statusText: "Internal Server Error" }));
                        reject(new Error("Simulated network error"));
                    }, 500);
                })
                : await fetch(url, request);

            if (!response) throw new Error('No response');

            const raw = await response.text(); // read the body once

            let result;
            try {
                result = JSON.parse(raw); // attempt to parse as JSON
            } catch {
                result = raw; // fallback to raw text
            }

            if (!response.ok) {
                const errorMessage = (typeof result === 'object' && result?.error) 
                    || (typeof result === 'string' && result)
                    || response.statusText
                    || 'Unknown error occurred';

                throw new Error(errorMessage);
            }

            return result;
        } catch (error) {
            throw error;
        } finally {
            $btn.querySelector('[data-ot-spinner]')?.remove();
        }
    },
    createSpinner() {
        const $spinner = document.createElement('span');
        $spinner.role = "status";
        $spinner.setAttribute('data-ot-spinner', '');
        $spinner.classList.add("ml-2");
        $spinner.innerHTML = spinnerIcon;

        return $spinner;
    },
    createSuccessStateElements(emailValue: string) {
        const $heading = document.createElement('h2');
        $heading.classList.add('bg-heading-pop', 'bg-clip-text', 'text-transparent');
        $heading.innerText = "Verify your email";

        const $body = document.createElement('p');
        $body.innerText = `We've sent an email to ${emailValue}. To complete your enrollment, click the link in the email. If you don't find it, check your junk folder.`;

        const $resendBtn = document.createElement('button') as HTMLButtonElement;
        $resendBtn.classList.add('flex', 'items-center', 'font-semibold', '!leading-none', 'rounded-md', 'border-2', 'px-5', 'py-3', 'lg:py-4', 'lg:px-6', 'gap-2', 'bg-surface-accent-gr', 'border-accent-strong', '[&:not(:disabled)]:hover:bg-none', '[&:not(:disabled)]:hover:bg-accent-strong', 'focus:outline-accent-weak', 'aria-disabled:opacity-30', 'aria-disabled:cursor-not-allowed');
        $resendBtn.innerText = "Resend verification email";

        const $status = document.createElement('div');
        $status.setAttribute('data-ot-success-status', '');
        $status.ariaLive = 'polite';

        const $help = document.createElement('p');
        $help.classList.add('text-sm');
        $help.innerHTML = 'Need help? <a href="https://www.opentext.com/contact">Contact us here</a>.';

        return { $heading, $body, $resendBtn, $status, $help };
    },
    populateHiddenFields($form: HTMLFormElement ) {
        // Apply UTMs, retrieved from URL Params
        const DATA_ATTR_UTM = 'data-ot-url-param-field';
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const $urlParamFields = $form.querySelectorAll(`[${DATA_ATTR_UTM}]`) as NodeListOf<HTMLInputElement>

        $urlParamFields.forEach($field => {
            const urlParamKey = $field.getAttribute(DATA_ATTR_UTM) || $field.name;
            const urlParamValue = urlParams.get(urlParamKey);

            urlParamValue && ($field.value = urlParamValue);
        });

        // Apply Google Analytics Client ID, retrieved from cookie
        function getGACID() {
            const match = document.cookie.match(/_ga=GA\d\.\d\.(\d+\.\d+)/);
            return match ? match[1] : '';
        }

        const $gaCidField = $form.querySelector(`[name="ga_cid"]`) as HTMLInputElement;
        const gaCid = getGACID();

        if ($gaCidField && gaCid) {
            $gaCidField.value = gaCid;
        } 

        // Apply 6Sense fields, retrieved from cookie
        const DATA_ATTR_6SENSE = 'data-ot-6sense-field';
        const _6senseCompanyDetailsString = localStorage.getItem('_6senseCompanyDetails');

        if (_6senseCompanyDetailsString) {
            const _6senseCompanyDetails = JSON.parse(_6senseCompanyDetailsString).company;
            const $6senseFields = $form.querySelectorAll(`[${DATA_ATTR_6SENSE}]`) as NodeListOf<HTMLInputElement>

            $6senseFields.forEach($field => {
                $field.value = _6senseCompanyDetails[$field.name.replace('6s_', '')];
            });
        }
    },
    showSuccessState($form: HTMLFormElement, formData: {[key: string]: string}, verificationId: string) {
        const $formSuccess = $form.parentElement?.querySelector('[data-ot-form-success]') as HTMLElement;

        // Don't continue if success state is already appended
        if (!$formSuccess.classList.contains('hidden')) {
            return;
        }

        const $formSuccessInner = $formSuccess?.querySelector('[data-ot-form-success-inner]') as HTMLElement;
        const { $heading, $body, $resendBtn, $status, $help } = this.createSuccessStateElements(formData.tenantUserEmail);
        const resendEndpoint = $form.getAttribute(this.FORM_DATA_ATTR) + '/resend-email/' + verificationId;

        $resendBtn.onclick = () => this.resendEmail($formSuccess, $resendBtn, resendEndpoint);

        $formSuccessInner.appendChild($heading);
        $formSuccessInner.appendChild($body);
        $formSuccessInner.appendChild($resendBtn);
        $formSuccessInner.appendChild($status);
        $formSuccessInner.appendChild($help);

        $form.classList.add('opacity-0');

        $form.addEventListener('transitionend', () => {
            $form.classList.add('hidden');
            $formSuccess.classList.remove('hidden');
            setTimeout(() => {
                // Magic settimeout. Without it, opacity does not transition. Couldn't find a better way.
                $formSuccess.classList.remove('opacity-0');
            });
        });
    }
}

function populateTestValues($form: HTMLFormElement) {
    const HONEYPOT_FIELD_NAME = 'middle_name';
    console.log('Populate Test Values');

    $form.querySelectorAll('input').forEach(input => {
        if (input.name === HONEYPOT_FIELD_NAME) {
            return;
        }

        if (input.type === 'text') {
            input.value = 'test_' + input.name;
        }

        if (input.type === 'email') {
            input.value = 'test@opentext.com'; // Change to your email to test receiving the confirmation email
        }

        if (input.type === 'password') {
            input.value = 'S2FtYmxpMTU5JA==';
        }

        if (input.type === 'checkbox') {
            input.checked = true;
        }
    });
}
